import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import StepPlaceholder from '../-components/StepPlaceholder';
import PreprocessingLoader from '../-components/PreprocessingLoader';
import { useStudyContext } from '../-components/study-context';

function DiagnoseRoute() {
  const { t } = useTranslation();
  const { study } = useStudyContext();

  if (study.status === 'preprocessing') {
    return (
      <PreprocessingLoader
        message={t('simopsRoutes.diagnose.preprocessingMessage')}
      />
    );
  }

  if (study.status === 'draft') {
    return (
      <StepPlaceholder
        title={t('simopsRoutes.diagnose.movedTitle')}
        message={t('simopsRoutes.diagnose.draftMessage')}
      />
    );
  }

  return (
    <StepPlaceholder
      title={t('simopsRoutes.diagnose.movedTitle')}
      message={t('simopsRoutes.diagnose.sharedMessage')}
    />
  );
}

export const Route = createFileRoute('/_app/simops/$studyId/diagnose')({
  component: DiagnoseRoute,
});
